// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** South Sudan */
const SS = /^(?:(?:12|9[1257-9])\d{7})$/;

export default SS;
